import { Card, CardContent, Typography, Box, Chip } from '@mui/material';

export default function ACHBankCard({ pm, selected = false, onSelect }) {
  if (!pm || pm.object !== 'payment_method') return null;
  const bank = pm.us_bank_account || {};
  const holder = pm.billing_details || {};
  const last4 = bank.last4 || '----';
  const bankName = bank.bank_name || 'Bank';
  const statusDetails = bank.status_details || {};
  const isVerified = Object.keys(statusDetails).length > 0;
  const networkPref = bank.networks?.preferred || 'ACH';

  return (
    <Card
      elevation={selected ? 8 : 3}
      onClick={() => onSelect && onSelect(pm)}
      sx={{
        width: '100%',
        height: 'auto',
        cursor: onSelect ? 'pointer' : 'default',
        borderRadius: 3,
        position: 'relative',
        background: selected
          ? 'linear-gradient(135deg, #ECFDF5, #FFFFFF)'
          : 'linear-gradient(135deg, #FFFFFF, #F7F7F7)',
        p: 2,
        transition: 'box-shadow .15s ease, transform .15s ease',
        '&:hover': {
          boxShadow: onSelect ? 6 : undefined,
          transform: onSelect ? 'translateY(-2px)' : undefined,
        },
        border: selected ? '2px solid #10B981' : '2px solid #E5E7EB'
      }}
    >
      <CardContent sx={{ p: 0, '&:last-child': { p: 0 }, display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between' }}>
        <Box
          display="flex"
          justifyContent="space-between"
          mb={'calc(var(--sp-md2)*1.5094339)'}
          sx={{ width: "100%", overflow: "hidden" }}
        >
          <Box display="flex" alignItems="center" gap={'calc(var(--sp-md2)*1.5094339)'} sx={{ minWidth: 0 }}>
            <Box
              sx={{
                width: 'calc(var(--fs-hero)*1.132075)',
                height: 'calc(var(--fs-hero)*1.132075)',
                borderRadius: "50%",
                backgroundColor: "#F3F4F6",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 'calc(var(--fs-xs)*2.26415)',
                objectFit: 'cover',
              }}
            >
              🏦
            </Box>

            <Box sx={{ minWidth: 0 }}>
              <Typography
                variant="h6"
                fontWeight={600}
                sx={{
                  lineHeight: 1.2,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "calc(var(--fs-hero)*4.245283)",
                  fontSize:'calc(var(--fs-xs)*1.8867924)'
                }}
              >
                {bankName}
              </Typography>

              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "calc(var(--fs-hero)*4.245283)",fontSize:'calc(var(--fs-xs)*1.3207547)'
                }}
              >
                {holder.name || "Account Holder"}
              </Typography>
            </Box>
          </Box>

          <Chip
            label={isVerified ? "Verified" : "Verification pending"}
            color={isVerified ? "success" : "warning"}
            variant="outlined"
            size="small"
            sx={{
              maxWidth: "calc(var(--fs-hero)*3.537735)",
              marginLeft: 'calc(var(--sp-md2)*1.8867924)',
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontSize:'calc(var(--fs-xs)*1.226415)',padding:'var(--sp-md2)', borderRadius:'calc(var(--sp-md2)*1.5094339)'
            }}
          />
        </Box>


        <Box mt={1}>
          <Typography variant="caption" color="text.secondary" sx={{ fontSize:'calc(var(--fs-xs)*1.132075)'}}>
            Account Number
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: 'space-between',
              alignItems: "center",
              gap: "calc(var(--sp-md2)*1.1320754)",
              mt: "calc(var(--sp-xxs)*2)",
              fontSize: "calc(var(--fs-xs)*1.8867924)",
              fontWeight: 600,
              letterSpacing: "calc(var(--sp-xxs)*0.5)",
              fontFamily: "Poppins, sans-serif",
            }}
          >
            <span>****</span>
            <span>****</span>
            <span>****</span>
            <span>{last4}</span>
          </Box>
        </Box>

        <Box mt={'calc(var(--sp-md2)*1.5094339)'} display="flex" alignItems="center" justifyContent="space-between" gap={'calc(var(--sp-md2)*1.5094339)'}>
          <Chip
            style={{ textTransform: 'capitalize',
                fontSize:'calc(var(--fs-xs)*1.226415)',padding:'var(--sp-md2)', borderRadius:'calc(var(--sp-md2)*1.5094339)'
             }}
            label={`Network: ${networkPref}`}
            size="small"
            variant="outlined"
          />
          {selected && (
            <Chip
              label="Default"
              size="small"
              variant="outlined"
              sx={{
                borderColor: '#10B981',
                color: '#10B981',
                fontWeight: 600,
                backgroundColor: '#FFFFFF',
                fontSize:'calc(var(--fs-xs)*1.226415)',padding:'var(--sp-md2)', borderRadius:'calc(var(--sp-md2)*1.5094339)'
              }}
            />
          )}
        </Box>
      </CardContent>
    </Card>
  );
}
